import { __assign } from "tslib";
import * as React from 'react';
function IconFacebookSizeM(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { d: "M9.10357 8.62338H11.2201L11.537 6.09512H9.10357V4.4809C9.10357 3.74893 9.30116 3.25005 10.3215 3.25005L11.6228 3.24943V0.988187C11.3976 0.957488 10.6252 0.888672 9.72659 0.888672C7.85039 0.888672 6.5659 2.06685 6.5659 4.23064V6.09519H4.44385V8.62345H6.56584V15.1109H9.10357V8.62338Z" })));
}
export default IconFacebookSizeM;
